export interface StorySection {
  title: string;
  content: string;
  audioFile: string;
  isSpecial?: boolean;
  gifUrl?: string;
}

export const parseMarkdown = (markdown: string): StorySection[] => {
  const sections: StorySection[] = [];
  const parts = markdown.split(/^## /m);

  try {
    const audioMap: { [key: string]: string } = {
      Light: require("../assets/Stories/Graengale Grove/Graengale Grove (Light).mp3"),
      Dämmerung: require("../assets/Stories/Graengale Grove/Graengalen Gehölz (Dämmerung).mp3"),
      Nacht: require("../assets/Stories/Graengale Grove/Graengalen Gehölz (Nachtlied).mp3"),
      Dunkel: require("../assets/Stories/Graengale Grove/Graengalen Gehölz (Dunkel).mp3"),
      Dawn: require("../assets/Stories/Graengale Grove/Graengale Grove (Dawn).mp3"),
      Morning: require("../assets/Stories/Graengale Grove/Graengale Grove (Morning Song).mp3"),
    };

    if (parts[0]) {
      sections.push({
        title: "By Valora Elderleaf",
        content: parts[0].trim(),
        audioFile: audioMap["Light"],
      });
    }

    for (let i = 1; i < parts.length; i++) {
      const lines = parts[i].split("\n");
      const title = lines[0].trim();
      const content = lines.slice(1).join("\n").trim();

      if (content && !content.startsWith("-")) {
        sections.push({
          title,
          content,
          audioFile: audioMap[title] || audioMap["Light"],
        });
      }
    }
  } catch (error) {
    console.error("Error loading audio files:", error);
  }

  return sections;
};

export const renderMarkdownToHTML = (content: string): string => {
  let result = content;

  result = result
    .split("\n\n")
    .map((para) => {
      if (!para.trim()) return "";

      let paragraph = para.replace(/\n/g, "<br>");

      paragraph = paragraph.replace(
        /\*\*_(.+?)_\*\*/g,
        "<strong><em>$1</em></strong>"
      );
      paragraph = paragraph.replace(
        /_\*\*(.+?)\*\*_/g,
        "<em><strong>$1</strong></em>"
      );

      paragraph = paragraph.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
      paragraph = paragraph.replace(/_(.+?)_/g, "<em>$1</em>");
      paragraph = paragraph.replace(/\*(.+?)\*/g, "<em>$1</em>");

      if (
        paragraph.trim().startsWith("&gt;") ||
        paragraph.trim().startsWith(">")
      ) {
        paragraph = paragraph.replace(/^(&gt;|>)\s*/, "");
        return `<blockquote>${paragraph}</blockquote>`;
      }

      // Handle [Verse X] markers
      if (paragraph.trim().startsWith("[Verse")) {
        return `<p class="verse-marker">${paragraph}</p>`;
      }

      return `<p>${paragraph}</p>`;
    })
    .join("");

  return result;
};
